<template>
    <!-- 大运流年组件:编辑 -->
    <div class="layout-comment-list">
        <van-collapse class="layout-cfc-collapse" v-model="activeDaYunNames" v-bind:border="false" @change="changeDaYun">
            <van-collapse-item class="layout-cfc-item" v-bind:border="false" v-for="dayunData of dayunLiunianList" v-bind:key="dayunData.name" v-bind:name='dayunData.name' v-bind:id="dayunData.name">
                <div class="layout-cfc-title" slot="title"><i class="iconfont cfc-icon" v-bind:class="{'icon-sanjiao': !dayunData || !dayunData.edited, 'icon-sanjiao-shi': dayunData && dayunData.edited}"></i>{{dayunData.year + '-' + (dayunData.year+dayunData.liunian.length-1) + dayunData.ganzhi}}{{dayunData.typeBefore ? '' : '大运'}}</div>
                <i slot="right-icon"></i>
                <div class="layout-cfc-content">
                    <!-- 1、大运主要内容 -->
                    <div class="layout-cfc-sub-content">
                        <div v-if="!dayunData.typeBefore" class="layout-cfc-subc-line">
                            <span class="layout-cfcsl-label">前五年运势:</span>
                            <comment-type-item v-for="dtype1 of dayunData.type" v-bind:key="'before-half-5' + dtype1.index + Math.random(0, 10)"
                                v-bind:parentData="{'dayun': dayunData.year}"
                                v-bind:itemData="dtype1"
                                v-bind:itemFunc="clickDayunType">
                            </comment-type-item>
                        </div>
                        <div v-if="!dayunData.typeBefore" class="layout-cfc-subc-line">
                            <span class="layout-cfcsl-label">后五年运势:</span>
                            <comment-type-item v-for="dtype2 of dayunData.type2" v-bind:key="'later-half-5' + dtype2.index + Math.random(0, 10)"
                                v-bind:parentData="{'dayun': dayunData.year}"
                                v-bind:itemData="dtype2"
                                v-bind:itemFunc="clickDayunType2">
                            </comment-type-item>
                        </div>
                        <div class="layout-cfc-subc-paragraph">
                            <comment-edit-panel 
                                v-bind:fromPage="'commentList'"
                                v-bind:parentData="{'dayun': dayunData.year}"
                                v-bind:textValue="dayunData.content"
                                v-bind:textId="dayunData.name"
                                v-bind:saveFunc="clickSaveDayun">
                            </comment-edit-panel>
                        </div>
                    </div>

                    <!-- 2、流年列表 -->
                    <van-collapse class="layout-cfc-sub-collapse" v-model="activeLiuNianNames" v-bind:border="false" @change="changeLiuNian">
                        <van-collapse-item class="layout-cfcsc-item" v-bind:border="false" v-for="liunianData of dayunData.liunian" v-bind:key="liunianData.year" v-bind:name="liunianData.name" v-bind:id="liunianData.name">
                            <div class="layout-cfcsc-title" slot="title"><i class="iconfont cfcsc-icon" v-bind:class="{'icon-circle': !liunianData || !liunianData.edited, 'icon-circle-shi': liunianData && liunianData.edited}"></i>{{liunianData.year}}	{{liunianData.ganzhi}}流年</div>
                            <i slot="right-icon"></i>
                            <div class="layout-cfc-sub-content">
                                <div class="layout-cfc-subc-line">
                                    <span class="layout-cfcsl-label">上半年运势:</span>
                                    <comment-type-item v-for="ltype1 of liunianData.type" v-bind:key="'before-half-year' + ltype1.index + Math.random(0, 10) "
                                        v-bind:parentData="{'dayun': dayunData.year, 'liunian': liunianData.year}"
                                        v-bind:itemData="ltype1"
                                        v-bind:itemFunc="clickLiuNianType">
                                    </comment-type-item>
                                </div>
                                <div class="layout-cfc-subc-line">
                                    <span class="layout-cfcsl-label">下半年运势:</span>
                                    <comment-type-item v-for="ltype2 of liunianData.type2" v-bind:key="'later-half-year' + ltype2.index + Math.random(0, 10) "
                                        v-bind:parentData="{'dayun': dayunData.year, 'liunian': liunianData.year}"
                                        v-bind:itemData="ltype2"
                                        v-bind:itemFunc="clickLiuNianType2">
                                    </comment-type-item>
                                </div>
                                <div class="layout-cfc-subc-paragraph">
                                    <comment-edit-panel 
                                        v-bind:fromPage="'commentList'"
                                        v-bind:parentData="{'dayun': dayunData.year, 'liunian': liunianData.year}"
                                        v-bind:textValue="liunianData.content"
                                        v-bind:textId="liunianData.name"
                                        v-bind:saveFunc="clickSaveLiuNian">
                                    </comment-edit-panel>
                                </div>
                            </div>
                        </van-collapse-item>
                    </van-collapse>
                </div>
            </van-collapse-item>
        </van-collapse>
    </div>
</template>

<script>
import CommentEditPanel from './CommentEditPanel.vue'
import CommentTypeItem from './CommentTypeItem.vue'
import { COMMENT_DOM } from '../../modules/dom';
export default {
    name: 'CommentList',
    components: {CommentEditPanel, CommentTypeItem},
    computed: {
        dayunLiunianList() {
            return this.$store.state.comment.dayunLiunianList;
        },
        activeDaYunNames: {
            get() {
                return this.$store.state.comment.activeDaYunNames;
            },
            set(value) {
                this.$store.state.comment.activeDaYunNames = value;
            }
        },
        activeLiuNianNames: {
            get() {
                return this.$store.state.comment.activeLiuNianNames;
            },
            set(value) {
                this.$store.state.comment.activeLiuNianNames = value;
            }
        }
    },
    data() {
        return {
            tempDaYunActiveNames: [],
            tempLiuNianActiveNames: []
        }
    },
    methods: {
        changeDaYun(activeNames) {
            if(activeNames.length > this.tempDaYunActiveNames.length) {
                var me = this, curName = activeNames[activeNames.length - 1];
                this.$store.dispatch('minifatefortune/triggerFortuneItemClick', curName);
                setTimeout(() => {
                    COMMENT_DOM.updateCommentFormScrollTop(curName, this.$store.state.comment.curActiveName);
                    me.$store.state.comment.curActiveName = curName;
                }, 200);
            }
            this.tempDaYunActiveNames = activeNames;
            console.log('changeDaYun', activeNames, this.activeDaYunNames)
        },
        changeLiuNian(activeNames) {
            if(activeNames.length > this.tempLiuNianActiveNames.length) {
                var me = this, curName = activeNames[activeNames.length - 1];
                this.$store.dispatch('minifatefortune/triggerFortuneItemClick', curName);
                setTimeout(() => {
                    COMMENT_DOM.updateCommentFormScrollTop(curName, this.$store.state.comment.curActiveName);
                    me.$store.state.comment.curActiveName = curName;
                }, 200);
            }
            this.tempLiuNianActiveNames = activeNames;
            console.log('changeLiuNian', activeNames, this.activeLiuNianNames)
        },
        // 改变大运流年的type和type2值的触发事件
        clickDayunType(parentData, itemData, choosed, cb) {
            var params = {
                type: 'dayun', key: 'type', parentData: parentData, itemData: itemData, choosed: choosed, cb: cb
            }
            this.$store.dispatch('comment/updatePiPanBig', params);
        },
        clickDayunType2(parentData, itemData, choosed, cb) {
            var params = {
                type: 'dayun', key: 'type2', parentData: parentData, itemData: itemData, choosed: choosed, cb: cb
            }
            this.$store.dispatch('comment/updatePiPanBig', params);
        },
        clickLiuNianType(parentData, itemData, choosed, cb) {
            var params = {
                type: 'liunian', key: 'type', parentData: parentData, itemData: itemData, choosed: choosed, cb: cb
            }
            this.$store.dispatch('comment/updatePiPanBig', params);
        },
        clickLiuNianType2(parentData, itemData, choosed, cb) {
            var params = {
                type: 'liunian', key: 'type2', parentData: parentData, itemData: itemData, choosed: choosed, cb: cb
            }
            this.$store.dispatch('comment/updatePiPanBig', params);
        },
        // 改变大运流年的content值的触发事件
        clickSaveDayun(text, parentData, cb) {
            var params = {
                type: 'dayun', key: 'content', parentData: parentData, text: text, cb: cb
            }
            this.$store.dispatch('comment/updatePiPanBig', params);
        },
        clickSaveLiuNian(text, parentData, cb) {
            var params = {
                type: 'liunian', key: 'content', parentData: parentData, text: text, cb: cb
            }
            this.$store.dispatch('comment/updatePiPanBig', params);
        }
    }
}
</script>